import { pagePaths } from 'config/pages';
import { CrmNotification } from 'types/SalesforceCrmNotifications.types';

const CRM_NOTIFICATION_DETAIL_PATH_BUILDERS: Partial<
  Record<string, (relatedId: string) => string>
> = {
  Account: (relatedId) =>
    pagePaths.salesforceAccountDetail.replace(':accountId', relatedId),
  Opportunity: (relatedId) =>
    pagePaths.salesforceOpportunityDetail.replace(':oppId', relatedId),
  Case: (relatedId) =>
    pagePaths.salesforceCaseDetail.replace(':caseId', relatedId),
  TreatmentPlan: (relatedId) =>
    pagePaths.salesforceTreatmentPlanDetail.replace(
      ':treatmentPlanId',
      relatedId
    ),
  TreatmentPlanVersion: (relatedId) =>
    pagePaths.salesforceTreatmentPlanVersionDetail.replace(
      ':treatmentPlanVersionId',
      relatedId
    ),
  Production: (relatedId) =>
    pagePaths.salesforceProductionDetail.replace(':productionId', relatedId)
};

export const getCrmNotificationDetailPath = (
  notification: CrmNotification
): string | undefined => {
  const { data, relatedType } = notification;
  if (!data?.recordId || !relatedType) return undefined;

  const pathBuilder = CRM_NOTIFICATION_DETAIL_PATH_BUILDERS[relatedType];
  const path = pathBuilder?.(data.recordId);
  if (!path) return undefined;

  return `${path}?activeTab=chatter`;
};
